// NPM Imports
import React from "react";

// Components Imports
import RevvEditorCheckbox from "./RevvEditorCheckbox";

// Actions Imports

// Internal Imports

// Destructuring

export default function RevvEditorCheckboxField({
  id,
  updateField,
  isDocInFinalStage,
  isReadOnly,
  className,
  isDisabled,
  isMagicLinkPage,
  options,
  filteredOptions,
  values,
  display,
  sectionId,
  inputFieldStyles,
}) {
  const _updateCheckboxField = ({ option, isChecked }) => {
    let newValues = [];
    options.forEach(opt => {
      if (opt === option) {
        if (isChecked) {
          newValues.push(option);
        }
      } else if (values.includes(opt)) {
        newValues.push(opt);
      }
    });

    const findOtherOptionValue = values.find(val => val.includes("Other : "));

    if (option.trim() === "Other") {
      if (!findOtherOptionValue) {
        newValues = [...newValues, "Other : "];
      }
    } else if (findOtherOptionValue && !option.startsWith("Other : ")) {
      newValues = [...newValues, findOtherOptionValue];
    }

    updateField(newValues, "CHECKBOX");
  };
  return (
    <>
      {Array.isArray(filteredOptions) &&
        filteredOptions.map((option, index) => (
          <>
            {/* ------ Checkbox as a checkbox input field ------ */}
            {display.show === "all" && (
              <RevvEditorCheckbox
                key={option}
                checkboxId={`${id}_${index}_${sectionId}`}
                option={option}
                isDisabled={isDisabled}
                values={values}
                updateCheckboxField={_updateCheckboxField}
                isDefaultChecked={
                  values.includes(option) ||
                  (index === filteredOptions.length - 1 &&
                    values.includes("Other : "))
                }
                isMagicLinkPage={isMagicLinkPage}
                isDocInFinalStage={isDocInFinalStage}
                isReadOnly={isReadOnly}
                className={className}
                inputFieldStyles={inputFieldStyles}
              />
            )}
            {/* ------ Checkbox as a only text field ------ */}
            {display.show === "selected" && (
              <span
                contentEditable={false}
                className={`${
                  display.direction === "vertical"
                    ? "vertically-aligned-cfield"
                    : ""
                }`}>
                {`${option}${
                  index !== options.length - 1 &&
                  display.direction === "horizontal"
                    ? ", "
                    : ""
                } `}
              </span>
            )}
          </>
        ))}
    </>
  );
}
